import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import FooterCard from "components/footers/PageFooter";
import PageHeader from "components/headers/PageHeader";
import EnquiryCard from "components/home-cards/EnquiryCard";
import ChecklistCard from "components/other-cards/ChecklistCard";

export default () => {
  useEffect(() => {
    document.body.style.overflow = 'auto'
  });
  return (
    <AnimationRevealPage>
      <PageHeader pageName="Visa Checklist" titleName="" />
      <br/><br/>
      <ChecklistCard/>
      <EnquiryCard />
      <FooterCard />
    </AnimationRevealPage>
  );
};
